import { RequestStateEnum } from '../ts-interfaces/fetch-manager';
const Touching = Symbol('touching');
export const RequestPromise = Symbol('promise');
function hasRecordIdentifier(op) {
  return 'recordIdentifier' in op;
}
export default class RequestCache {
  constructor() {
    this._pending = Object.create(null);
    this._done = Object.create(null);
    this._subscriptions = Object.create(null);
  }
  enqueue(promise, queryRequest) {
    let query = queryRequest.data[0];
    if (hasRecordIdentifier(query)) {
      let lid = query.recordIdentifier.lid;
      let type = query.op === 'saveRecord' ? 'mutation' : 'query';
      if (!this._pending[lid]) {
        this._pending[lid] = [];
      }
      let request = {
        state: RequestStateEnum.pending,
        request: queryRequest,
        type
      };
      request[Touching] = [query.recordIdentifier];
      request[RequestPromise] = promise;
      this._pending[lid].push(request);
      this._triggerSubscriptions(request);
      promise.then(result => {
        this._dequeue(lid, request);
        let finalizedRequest = {
          state: RequestStateEnum.fulfilled,
          request: queryRequest,
          type,
          response: {
            data: result
          }
        };
        finalizedRequest[Touching] = request[Touching];
        this._addDone(finalizedRequest);
        this._triggerSubscriptions(finalizedRequest);
      }, error => {
        this._dequeue(lid, request);
        let finalizedRequest = {
          state: RequestStateEnum.rejected,
          request: queryRequest,
          type,
          response: {
            data: error && error.error
          }
        };
        finalizedRequest[Touching] = request[Touching];
        this._addDone(finalizedRequest);
        this._triggerSubscriptions(finalizedRequest);
      });
    }
  }
  _triggerSubscriptions(req) {
    req[Touching].forEach(identifier => {
      if (this._subscriptions[identifier.lid]) {
        this._subscriptions[identifier.lid].forEach(callback => callback(req));
      }
    });
  }
  _dequeue(lid, request) {
    this._pending[lid] = this._pending[lid].filter(req => req !== request);
  }
  _addDone(request) {
    request[Touching].forEach(identifier => {
      if (!this._done[identifier.lid]) {
        this._done[identifier.lid] = [];
      }
      // TODO add support for multiple
      let requestDataOp = request.request.data[0].op;
      this._done[identifier.lid] = this._done[identifier.lid].filter(req => {
        // TODO add support for multiple
        let data;
        if (req.request.data instanceof Array) {
          data = req.request.data[0];
        } else {
          data = req.request.data;
        }
        return data.op !== requestDataOp;
      });
      this._done[identifier.lid].push(request);
    });
  }
  subscribeForRecord(identifier, callback) {
    if (!this._subscriptions[identifier.lid]) {
      this._subscriptions[identifier.lid] = [];
    }
    this._subscriptions[identifier.lid].push(callback);
  }
  getPendingRequestsForRecord(identifier) {
    if (this._pending[identifier.lid]) {
      return this._pending[identifier.lid];
    }
    return [];
  }
  getLastRequestForRecord(identifier) {
    let requests = this._done[identifier.lid];
    if (requests) {
      return requests[requests.length - 1];
    }
    return null;
  }
}